<template>
  <div class="DetailU">
    <div class="content-info">
      <div class="">
        <p class="o-b t-i">Detalle de usuario</p>
        <div class="info-u-c">
          <img class="img_user" :src=userDetail.avatar>
          <div class="info-u">
            <p>{{userDetail.name}}</p>
            <p>{{userDetail.email}}</p>
            <p>{{userDetail.phone}}</p>
            <p>Usuario desde {{userDetail.createdAt}}</p>
          </div>
          <div class="info-ac p-top">
            <!--<button v-if="userDetail.blocked == false" v-on:click="bloquear(userDetail)" class="o-b but-r " id="basic-addon1">Bloquear</button>
            <button v-if="userDetail.blocked == true" v-on:click="desbloquear(userDetail)" class="o-b but-r " id="basic-addon1">Desbloquear</button>-->
            <button v-if="role != userRoleProfesional"  v-on:click="convertir(userDetail)" class="o-b btn-f but-c " id="basic-addon1">Convertir en estilista</button>
          </div>
        </div>
        <div class="b-c">
          <p class="o-b sub-t">Reservaciones</p>
          <button v-on:click="activeUR = !activeUR" class="f-r btn-t">
            <i v-bind:class="!activeUR ? 'fa-angle-up' : 'fa-angle-down'" class="fa" aria-hidden="true"></i>
            </button>
          <div v-bind:class="{'c-t-info-h-active': activeUR}" class="c-t-info">
            <table class="table table-light m-top">
              <thead>
                <tr>
                  <th scope="col">Fecha</th>
                  <th scope="col">Servicio</th>
                  <th scope="col">Pago</th>
                  <th scope="col">Código promocional</th>
                  <th scope="col">Estilista</th>
                  <th scope="col">Estatus</th>
                  <th scope="col">Horario</th>
                  <th scope="col">Comentarios</th>
                  <th scope="col">Rating Servicio</th>
                  <th scope="col">Rating Estilista</th>
                </tr>
              </thead>
              <tbody>

                <tr v-for="(data, index) in appointment" :key="index" >
                  
                  <td>{{data.date}}</td>
                  <td>{{data.service.name}}</td>
                  <td>${{data.finalAmount}}</td>
                  <td v-if="data.data.promocode"> {{data.data.promocode.code}} </td> <td v-else> - </td> 
                  <td v-if="typeof data.professional !== 'undefined'">{{data.professional.fullname}}</td><td v-else> - </td>
                  <td>{{data.status}}</td>
                  <td>{{data.hour}}</td>
                  <td><button v-on:click="comentario(data.comment)" class="btn-actions"><img src="@/assets/images/acciones.png" alt="acciones" /></button></td>
                  <td v-if="typeof data.rating === 'undefined' "> - </td><td v-else> {{data.rating}}/5 </td>
                  <td v-if="typeof data.ratingProfessional === 'undefined' "> - </td><td v-else> {{data.ratingProfessional}}/5 </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="b-c">
          <p class="o-b sub-t">Tarjetas Registradas</p>
          <button v-on:click="activeTR = !activeTR" class="f-r btn-t"><i class="fa fa-angle-down" aria-hidden="true"></i></button>
          <div v-bind:class="{'c-t-info-h-active': activeTR == true}" class="c-t-info">
            <table class="table table-light m-top">
              <thead>
                <tr>
                  <th scope="col">Marca de aceptación</th>
                  <th scope="col">Ultimos 4 digitos</th>
                  <th scope="col">Nombre en tarjeta</th>
                  <th scope="col">Vencimiento</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in cards" :key="index" >
                  <td>{{data.brand}}</td>
                  <td>{{data.lastFour}}</td>
                  <td>{{data.cardHolderName}}</td>
                  <td>{{data.expYear}}/{{data.expMonth}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="b-c">
          <p class="o-b sub-t">Direcciones Registradas</p>
          <button v-on:click="activeDR = !activeDR" class="f-r btn-t"><i class="fa fa-angle-down" aria-hidden="true"></i></button>
          <div v-bind:class="{'c-t-info-h-active': activeDR == true}" class="c-t-info">
            <table class="table table-light m-top">
              <thead>
                <tr>
                  <th scope="col">Direccion</th>
                  <th scope="col">Referencias</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in addresses" :key="index" >
                  <td>{{data.fullAddress}}</td>
                  <td>{{data.references}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>

import User from '../parse/models/User'

export default {
  name: 'DetailU',
  components: {
  },
  data () {
    return {
      activeUR: true,
      activeTR: false,
      activeDR: false,
      id: this.$route.params.id,
      userDetail: {},
      cards: [],
      appointment: [],
      service: {},
      addresses: [],
      userRoleProfesional: "4aYcG3DVXG",
      userProfessional: [],
      role: "",
      latitude: "",
      longitude: ""
    }
  },
  beforeMount(){
    User.detail(this.id)
    .then(user => {
      this.userDetail = user
      this.role = user.role.id
      
      user.loadCards()
        .then(cards => this.cards = cards)
        .catch(error => console.log(error))

      user.loadAppointment()
        .then(appointment => this.appointment = appointment)
        .catch(error => console.log(error))
      
      user.loadDirections()
        .then(addresses => this.addresses = addresses)
        .catch(error => console.log(error))
      
    })
    .catch(error => console.log(error))
  },
  methods: {
  
    convertir(user){
      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro de que quieres convertir a este usuario a estilista?',
        type: 'warning',
        confirmButtonText: 'Convertir',
        showCloseButton: true,
        showLoaderOnConfirm: true

      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Este usuario es estilista', 'success')
            User.convertUser(user)
            .then(resultado => this.reload())
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },

    bloquear(user){
      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro de que quieres bloquear al usuario?',
        type: 'warning',
        confirmButtonText: 'Bloquear',
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(result => {
        if(result.value) {
          this.$swal('', 'Usuario bloqueado', 'success')
            User.blocked(user)
            .then(resultado => this.reload())
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      });
    },

    desbloquear(user){
      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro de que quieres desbloquear al usuario?',
        type: 'warning',
        confirmButtonText: 'Desbloquear',
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(result => {
        if(result.value) {
          this.$swal('', 'Usuario desbloqueado', 'success')
            User.notblocked(user)
            .then(resultado => this.reload() )
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      });
    },
    reload(){
      User.detail(this.id)
        .then(user => {
          this.userDetail = user
          this.role = user.role.id

          
          user.loadCards()
            .then(cards => this.cards = cards)
            .catch(error => console.log(error))

          user.loadAppointment()
            .then(appointment => this.appointment = appointment)
            .catch(error => console.log(error))
          
          user.loadDirections()
            .then(addresses => this.addresses = addresses)
            .catch(error => console.log(error))
          
        })
        .catch(error => console.log(error))
    },

    comentario(comment){
      this.$swal({
        title: 'Comentario',
        text: comment,
        showCloseButton: false,
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /* Init detail*/
  .btn-actions{
    background: #f6f6f6;
    border: none;
  }
  .c-t-info{
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
  }

  .c-t-info-h-active{
    height: auto;
    max-height: 600px;
  }

  /* USER INFO */
  .img_user{
    width: 138px;
    height: 138px;
    border-radius: 70px;
    float: left;
    margin-right: 20px;
  }

  .info-u{
    display: inline;
  }

  .info-ac button{
    display: inline;
  }

  table tbody tr{
    background: #F3F3F3;
  }

  .but-r{
    background: #E96369;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
  }

  .but-r:hover{ 
    background: rgb(231, 76, 84);
  }

  .but-c{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 270px;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
  }

  .but-c:hover{ 
    background: #14fc78;
  }
  
  

  .m-r{
    margin-right: 50px;
  }

  .dropdown-menu{
    width: 120px;
  }

  /* Container */
  
  .content-info{
    margin-left: 310px;
    margin-right: 50px;
  }

  .c-i-c{
    width: 235px;
    height: 51px;
    background: #000;
    text-align: center;
    border-radius: 20px;
  }

  .t-u-c{
    padding-top: 14px;
    color: #fff;
    font-size: 16px;
  }

  .b-c {
    margin-right: 50px;
    margin-top: 37px;
    border: 1px solid #f6f6f6;
    -webkit-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    -moz-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    padding: 15px;
  }

  .sub-t{
    font-size: 18px;
    display: inline;
  }

  .i-f-s{
    width: 25px;
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .c-f-g{
    background: #f3f3f3;
    border: none;
    padding: 2px;
    height: 40px;
  }

  .but-g{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
  }
  .but-g:hover{ 
    background: #14fc78;
  }

  .btn-f{
    margin: 0 40px 0 20px;
  }

  .f-r{
    float: right;
  }

  .btn-t{
    background: #fff;
    border: none;
  }

  .s-o{
    background: #f3f3f3;
    border: none;
    font-family: "Open regular";
    font-size: 16px;
    padding: 5px;
  }

  .s-o option{
    padding: 5px;
  }

  .table{
    border: 1px solid #f6f6f6;
    text-align: center;
  }


</style>
